import api from './baseApi'

export function getPackages() {
    return api.get(`RechargePackage`)
}

export function getPackage(id) {
    return api.get(`RechargePackage/${id}`)
}
